import React from "react";
import { Link } from "react-router-dom";

function MediaCmsLeftBarMenu({activeMenu="magazine"}) {
  return (
    <div className="col-xl-2 col-lg-3 c-w">
      <div id="left_footer_pane_media_page" className="d-dsk mt-50 mt-sm-0">
        <div className="left-pane-footer-pages">
          <h3 className="about-heading">
            <b>Press And Events</b>
          </h3>
          <p className="mt-25">
            <Link
              to="/press-and-media/magazine"
              className={`about-menu-item ${activeMenu==='magazine' ? ' active' : ''}`}
            >
              Magazine
            </Link>
          </p>
          <p className="mt-15">
            <Link to="/press-and-media" className={`about-menu-item ${activeMenu==='press-and-media' ? ' active' : ''}`}>
              Press Release
            </Link>
          </p>
          <p className="mt-15">
            <Link to="/news" className={`about-menu-item ${activeMenu==='news' ? ' active' : ''}`}>
              News
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default MediaCmsLeftBarMenu;
